<template>
  <BaseModal
    :title="$t('message.memberGetMember.faqModal.title')"
    :modal-width="modalWidth"
    hookSufix="FaqMemberGetMember"
    disableDefaultPadding
    :borderedToolbar="true"
    class="base-modal"
    :paddingTop="'8px'"
    :fullscreen="isMobileBreakpoint"
    :min-height="minHeight"
  >
    <template #subtitle>
      <p class="body-regular-smaller neutral-40-light--text mt-1">
        {{ $t('message.memberGetMember.faqModal.subtitle') }}
        <a
          :href="$t('message.memberGetMember.faqModal.articleUrl')"
          type="secondary"
          size="xsmall"
          class="body-bold-smaller neutral-30-base--text"
          target="_blank"
          >{{ $t('message.memberGetMember.faqModal.article') }}
          <v-icon size="12" color="neutral-30-base">mdi-open-in-new</v-icon></a
        >
      </p>
    </template>
    <template #content>
      <div
        class="container-content"
        :class="{ 'w-full-vw': isMobileBreakpoint }"
      >
        <div class="d-grid">
          <span class="body-bold-medium mt-2 mb-2">{{
            $t('message.memberGetMember.faqModal.objectiveTitle')
          }}</span>
          <span class="body-regular-smaller neutral-30-base--text">
            {{ $t('message.memberGetMember.faqModal.objectiveSubtitle') }}
          </span>
        </div>
        <div class="d-grid">
          <span class="body-bold-medium mt-4 mb-2">{{
            $t('message.memberGetMember.faqModal.rewardsTitle')
          }}</span>
          <span class="body-regular-smaller neutral-30-base--text">
            <span class="fw-700">{{
              $t('message.memberGetMember.faqModal.rewards.forRefererTitle')
            }}</span>
            {{
              $t('message.memberGetMember.faqModal.rewards.forRefererText', {
                price: userPlan.currency == 'brl' ? 'R$150' : '$30',
              })
            }}
          </span>
          <span class="body-regular-smaller neutral-30-base--text">
            <span class="fw-700">{{
              $t('message.memberGetMember.faqModal.rewards.forRefereredTitle')
            }}</span>
            {{
              $t('message.memberGetMember.faqModal.rewards.forRefereredText', {
                price: userPlan.currency == 'brl' ? 'R$180' : '$40',
                cost: userPlan.currency == 'brl' ? 'R$30' : '$10',
                value: userPlan.currency == 'brl' ? 'R$150' : '$30',
              })
            }}
          </span>
        </div>
        <div class="d-grid">
          <span class="body-bold-medium mt-4 mb-2">{{
            $t('message.memberGetMember.faqModal.howWorkTitle')
          }}</span>
          <span class="body-regular-smaller neutral-30-base--text">
            <span class="fw-700">{{
              $t('message.memberGetMember.faqModal.howWork.referralLimitTitle')
            }}</span>
            {{
              $t('message.memberGetMember.faqModal.howWork.referralLimitText')
            }}
          </span>
          <span class="body-regular-smaller neutral-30-base--text">
            <span class="fw-700">{{
              $t(
                'message.memberGetMember.faqModal.howWork.discountBalanceTitle'
              )
            }}</span>
            {{
              $t('message.memberGetMember.faqModal.howWork.discountBalanceText')
            }}
          </span>
        </div>
        <v-divider class="my-4 w-full" />
        <div class="d-grid">
          <span class="body-bold-medium">FAQ</span>
          <span class="body-bold-small neutral-20-dark--text">
            {{ $t('message.memberGetMember.faqModal.faq.firstTitleQuestion') }}
          </span>
          <span class="body-regular-smaller neutral-30-base--text">
            {{
              $t('message.memberGetMember.faqModal.faq.firstQuestion', {
                price: userPlan.currency == 'brl' ? 'R$150' : '$30',
              })
            }}
          </span>
          <span class="body-bold-small neutral-20-dark--text">
            {{ $t('message.memberGetMember.faqModal.faq.secondTitleQuestion') }}
          </span>
          <span class="body-regular-smaller neutral-30-base--text">
            {{ $t('message.memberGetMember.faqModal.faq.secondQuestion') }}
          </span>
          <span class="body-bold-small neutral-20-dark--text">
            {{ $t('message.memberGetMember.faqModal.faq.thirdTitleQuestion') }}
          </span>
          <span class="body-regular-smaller neutral-30-base--text">
            {{ $t('message.memberGetMember.faqModal.faq.thirdQuestion') }}
          </span>
          <span class="body-bold-small neutral-20-dark--text">
            {{ $t('message.memberGetMember.faqModal.faq.fourthTitleQuestion') }}
          </span>
          <span class="body-regular-smaller neutral-30-base--text">
            {{
              $t('message.memberGetMember.faqModal.faq.fourthQuestion', {
                price: userPlan.currency == 'brl' ? 'R$150' : '$30',
              })
            }}
          </span>
          <span class="body-bold-small neutral-20-dark--text">
            {{ $t('message.memberGetMember.faqModal.faq.fifthTitleQuestion') }}
          </span>
          <span class="body-regular-smaller neutral-30-base--text">
            {{ $t('message.memberGetMember.faqModal.faq.fifthQuestion') }}
          </span>
        </div>
      </div>
    </template>
  </BaseModal>
</template>
<script>
import { mask } from 'vue-the-mask'
import { mapState } from 'vuex'
import BaseModal from '@/components/BaseModal.vue'

// internal imports
import linkHelper from '@/utils/linkHelper.mixin.js'
// components

//mixins
import logoBonificationMixin from '@/utils/logoBonification.mixin.js'
export default {
  name: 'MemberGetMember',
  directives: { mask },
  components: {
    BaseModal,
  },
  mixins: [linkHelper, logoBonificationMixin],
  data: () => ({
    openModalPixel: false,
  }),
  computed: {
    ...mapState({
      userPlan: (state) => state.user.userPlanInfo,
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
      isPandaBrandingBonusEnabled: (state) =>
        state.user.isPandaBrandingBonusEnabled,
    }),
    minHeight() {
      return this.isMobileBreakpoint ? '100%' : ''
    },
    modalWidth() {
      return !this.isMobileBreakpoint ? '856px' : '100%'
    },
  },

  mounted() {},
}
</script>
<style lang="scss" scoped>
.container-content {
  overflow: auto;
  height: 600px;
  padding: 12px 24px 24px 24px;
}
.w-full-vw {
  width: 100vw;
}
.d-grid {
  display: grid;
  width: 100%;
  gap: 4px;
}
.w-full {
  width: 100%;
}
.fw-700 {
  font-weight: 700;
}

@media screen and (max-height: 700px) {
  .container-content {
    overflow: auto;
    height: 520px;
  }
}
</style>
